<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" :width="width" :height="height"><g stroke-linecap="round" stroke-linejoin="round" :stroke-width="strokewidth" :fill="_secondaryfill" :stroke="_secondaryfill"><rect x="6" y="2" width="36" height="44" fill="none" :stroke="fill"></rect><line x1="24" y1="10" x2="24" y2="38" fill="none"></line><path d="M30.75,14.438C27.508,12.655,17.3,11.326,17.3,17.464c0,7.348,12.967,4.755,12.967,11.238S21.835,34.7,16,32.591" fill="none"></path></g></svg></template>

<script>
export default {
	props: {
		width: {
			type: [Number, String],
			default: "100%"
		},
		height: {
			type: [Number, String],
			default: "100%"
		},
		strokewidth: {
			type: [Number, String],
			default: 1
		},
		fill: {
			type: String,
			default: "currentColor"
		},
		secondaryfill: {
			type: String
		}
	},
	computed: {
		_secondaryfill: function () {
			return this.secondaryfill || this.fill
		}
	}
}
</script>